import React from 'react'
import { Text } from '../../elements/Text/Text'

export interface HandwrittenProps {
    text: string
    transform: string
}

const HandwrittenText = ({ text, transform }: HandwrittenProps) => {
    return (
        <Text
            variant={'handWritten'}
            size={6}
            css={{
                transform: transform,
                maxWidth: '14rem',
                textAlign: 'center',
                color: '#3D7CF6',
                lineHeight: '1.5rem',
                letterSpacing: '.04rem',
                marginBottom: '0.25rem',
            }}
        >
            {text}
        </Text>
    )
}

export default HandwrittenText
